import { render, staticRenderFns } from "./BetgameEditColors.vue?vue&type=template&id=ba42e772&scoped=true"
import script from "./BetgameEditColors.vue?vue&type=script&lang=js"
export * from "./BetgameEditColors.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditColors.vue?vue&type=style&index=0&id=ba42e772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba42e772",
  null
  
)

export default component.exports